/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import { a11y, mixins } from '@blend/consumer-components';

const styles = StyleSheet.create({
  srOnlyContentText: mixins.hideOnMobile(),
});

export namespace ScreenReaderMessage {
  export interface Props extends React.HTMLAttributes<HTMLSpanElement> {
    hideOnMobile?: boolean;
  }
}
export const ScreenReaderMessage: React.SFC<ScreenReaderMessage.Props> = ({ children, hideOnMobile, ...htmlProps }) => (
  <span className={css(a11y.srOnly, hideOnMobile && styles.srOnlyContentText)} tabIndex={-1} {...htmlProps}>
    {children}
  </span>
);
